// eslint-disable-next-line no-unused-vars
import APIV5 from '~/models/api';
import { COMPOSED_OF } from '~/scripts/constants/common-kids';

/* globals Knitiv */

export default class ModalTemplateList {
	/* @ngInject */
	/**
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {*} node
	 * @param {Knitiv.Scope} $scope
	 */
	constructor($translate, $uibModalInstance, node, $scope) {
		/** @type {any[]} */
		this.templates = [];
		this.selectedElement = null;
		this.isLoading = true;
		this.node = node;
		/** @type {import('angular').ui.bootstrap.IModalInstanceService} */
		this.$uibModalInstance = $uibModalInstance;
		/** @type {import('angular').translate.ITranslateService} */
		this.$translate = $translate;
		/** @type {Knitiv.Scope} */
		this.$scope = $scope;
	}

	/**
	 * @param {any} key
	 */
	setCurrentSelected(key) {
		this.selectedElement = key;
	}

	ok() {
		this.$uibModalInstance.close({
			kid: this.selectedElement,
		});
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}

	async $onInit() {
		try {
			const data = await APIV5.instance.objectInfo({ kid: this.node }, { id: 'template-export-modal' });
			const templates = await APIV5.instance.objectList({
				classKid: 'K_NODE;KEXPTPLT',
				condition: {
					link: {
						relation_kid: COMPOSED_OF,
						class_kid: 'K_NODE;ANYTHING',
						linker_kid: '0',
						objnum2: data.isa.objid,
					},
				},
			}, { id: 'template-export-modal' });

			this.$scope.$evalAsync(() => {
				this.templates = Object.values(templates.list);
				this.isLoading = false;

				/** @type {Partial<import('@knitiv/api-client-javascript').ObjectListOutput['list'][0]>} */
				const template = {
					kid: 'K_NODE;0',
					repre_all: {
						'K_NODE;UNIVERSEL': {
							name: 'Template par défaut',
							lang_isa: 'K_NODE;LANGUE',
						},
					},
				};
				this.templates.push(template);
			});
		}
		catch (error) {
			console.error(error);
		}
		return true;
	}
}
